
@if ((enableEditButton && hideShow) || viewForm) {
  <div class="shade-white review-each-wrapper mat-elevation-z3">
    <div class="row">
      <div class="col-md-11">
        <div class="block-wrapper">
          <h2>{{ title }}</h2>
        </div>
      </div>
    </div>
    <div class="row review-instruction-wrapper">
      @for (comment of data.comments; track comment) {
        <div class="block-wrapper">
          @if (comment.projectComment || (comment.specifiedTR && comment.specifiedMoisture) || comment.dryTR) {
            <div>
              <h4 class="bold">{{getPrecastSampleTypeName(comment.sampleTypeMasterId)}}</h4>
              @if (comment.projectComment) {
                <p style="white-space: pre-wrap;">{{ comment.projectComment }}</p>
              }
              @if ((comment.specifiedTR && comment.specifiedMoisture) || comment.dryTR) {
                <p class="thermal-requirement-line">
                  No higher than@if (comment.specifiedTR && comment.specifiedMoisture) {
                  {{ comment.specifiedTR }} at {{ comment.specifiedMoisture }} moisture content
                  }@if (comment.specifiedTR && comment.specifiedMoisture && comment.dryTR) {
                  and at
                  }@if (comment.dryTR) {
                  {{ comment.dryTR }} in totally dry conditions (0%)
                  }.
                </p>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
}
<!-- new view submission form  include checkbox-->

@if (soiltype) {
  <div>
    @if ((enableEditButton && hideShow) || !viewForm) {
      <div class="shade-white review-each-wrapper mat-elevation-z3">
        <form [formGroup]="form">
          <div class="row">
            <div class="col-md-11">
              <div class="block-wrapper">
                <h2>{{ title }}</h2>
              </div>
            </div>
            @if (enableEditButton && !hideShow && !viewForm  && isFlagged) {
              <div
                class="no-print col-md-1 btn-wrap r-edit-wraper"
                formGroupName="commentInfo"
                >
                <mat-checkbox color="primary" formControlName="comments"> </mat-checkbox>
              </div>
            }
          </div>
        </form>
        <div class="row review-instruction-wrapper" [style.color]="form.get('commentInfo.comments')?.value ? '#d33' : 'inherit'">
          @for (comment of data.comments; track comment) {
            <div class="block-wrapper">
              @if (comment.projectComment || (comment.specifiedTR && comment.specifiedMoisture) || comment.dryTR) {
                <div>
                  <h4 class="bold">{{getPrecastSampleTypeName(comment.sampleTypeMasterId)}}</h4>
                  @if ((comment.specifiedTR && comment.specifiedMoisture) || comment.dryTR) {
                    <p class="thermal-requirement-line">
                      No higher than@if (comment.specifiedTR && comment.specifiedMoisture) {
                      {{ comment.specifiedTR }} at {{ comment.specifiedMoisture }} moisture content
                      }@if (comment.specifiedTR && comment.specifiedMoisture && comment.dryTR) {
                      and at
                      }@if (comment.dryTR) {
                      {{ comment.dryTR }} in totally dry conditions (0%)
                      }.
                    </p>
                  }
                  @if (comment.projectComment) {
                    <p style="white-space: pre-wrap;">{{ comment.projectComment }}</p>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}